import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// `withCredentials` sends the HttpOnly auth cookie on every request. No token
// is stored in JS-accessible storage anymore, mitigating XSS session theft.
export const api = axios.create({ baseURL: API, withCredentials: true });
